import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox, Col, Image, Input, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { MasterProductReq, ImportProductReq, Data } from 'Store/product/types'
import { getMasterProductAPI, importProductAPI } from 'Store/product/api'
import { selectActionEvent, selectMasterProductList, selectDetailEvent } from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { SelectItem } from 'Components/form'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/product/actions'
// import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import styled from 'styled-components'
import { appConfig } from 'config'
import { SearchOutlined } from '@ant-design/icons'
import Label from 'Components/text/Label'
import { MyTheme } from 'Components/common/Theme'
import { MasterMerchant } from 'Store/merchants/types'
import { getMenuSelect } from 'helpers/format'
import { ImageFallback, menuMasterProductStatus } from 'helpers/constanst'
import { ConfirmDailog } from 'Components/modal'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  masterMerchant?: MasterMerchant[]
}

const ImportProduct: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    dataList,
    detailEvent,
    masterMerchant = [],
  } = props

  const datas = dataList.data
  const meta = dataList.meta

  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 20,
  })
  const [filter, setFilter] = useState({
    keyword: '',
    merchant_id: 0,
    skip_exists: 0,
  })

  const [selectProduct, setSelectProduct] = useState([] as number[])
  const [confirmImportDailog, setConfirmImportDailog] = useState(false)
  const dispatch = useDispatch()

  const title = 'เลือกสินค้าที่ต้องการนำเข้า'

  useEffect(() => {
    return () => {
      setSelectProduct([])
      pagination.Page = 1
      pagination.RowPerPage = 20
      setPagination({ ...pagination })
    }
  }, [visible])

  useEffect(() => {
    if (currentUser?.accessToken && visible) {
      onGetMasterProduct()
    }
  }, [pagination])

  const onImport = (ids: number[]): void => {
    const req: ImportProductReq = {
      ids,
    }
    dispatch(importProductAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetMasterProduct = (): void => {
    const req: MasterProductReq = {
      product_name: filter.keyword?.trim() || '',
      merchant_id: filter.merchant_id,
      skip_exists: filter?.skip_exists > 0 ? true : false,
      //per_page: pagination.RowPerPage,
      page: pagination.Page,
    }
    dispatch(getMasterProductAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const isSelect = (productID: number) => {
    return selectProduct.includes(productID)
  }

  const removeID = (productID: number) => {
    return selectProduct.filter((item: number) => item !== productID)
  }

  const onSelectProduct = (productID: number) => {
    let newSelect = selectProduct
    if (isSelect(productID)) {
      newSelect = removeID(productID)
    } else {
      newSelect.push(productID)
    }
    setSelectProduct([...newSelect])
  }

  const onConfirmImport = () => {
    onImport(selectProduct)
    onCloseConfirmImport()
  }

  const onOpenConfirmImport = () => {
    setConfirmImportDailog(true)
  }

  const onCloseConfirmImport = () => {
    setConfirmImportDailog(false)
  }

  const renderImage = (img: string[]) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img[0]} fallback={ImageFallback} />
  )

  const renderCategory = (group: any, record: Data) =>
    `${group?.name || ''} / ${record.category?.name || ''} / ${record.sub_category?.name || ''}`

  const renderActionButton = (id: number, record: Data) => {
    return (
      <Space size="small" wrap={true} direction="vertical">
        <Checkbox onChange={() => onSelectProduct(record.id)} checked={isSelect(record.id)} />
        {record.exists && <WarningText>*นำเข้าแล้ว</WarningText>}
      </Space>
    )
  }

  const columns = [
    {
      title: 'เลือก',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
      width: '80px',
      align: 'center',
    },
    {
      title: 'รูปภาพสินค้า',
      dataIndex: 'photos',
      key: 'photos',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'manufacturer',
      key: 'manufacturer',
      render: (manufacturer: any) => manufacturer?.name || '-',
    },
    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group',
      key: 'group',
      render: renderCategory,
    },
    {
      title: 'ร้านค้า/แบรนด์',
      dataIndex: 'merchant',
      key: 'merchant',
      render: (merchant: any) => merchant?.name || '-',
    },
  ]

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
      changePerPage={false}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[16, 16]}>
        <Col md={6} xs={24}>
          <SearchInput
            placeholder="ค้นหาชื่อ,รหัสสินค้า"
            prefix={<SearchOutlined />}
            allowClear
            value={filter.keyword}
            onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
          />
        </Col>
        <Col md={6} xs={24}>
          <SelectItem
            name={'merchant_id'}
            label={''}
            isRequired={true}
            value={filter.merchant_id}
            menu={getMenuSelect(masterMerchant)}
            placeHolder={'เลือกร้านค้า'}
            onChange={(val: string): any => onFilter('merchant_id', val)}
          />
        </Col>
        <Col md={6} xs={24}>
          <SelectItem
            name={'skip_exists'}
            label={''}
            isRequired={true}
            value={filter.skip_exists}
            menu={menuMasterProductStatus}
            placeHolder={'สถานะสินค้า'}
            onChange={(val: string): any => onFilter('skip_exists', val)}
          />
        </Col>
        <Col>
          <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onGetMasterProduct} />
        </Col>
      </Row>
    </FilterWrapper>
  )

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton
        disabled={selectProduct.length <= 0}
        text={`นำเข้าสินค้า (${selectProduct.length} รายการ)`}
        onClick={onOpenConfirmImport}
      />
    </Space>
  )

  const ConfirmImport = (
    <ConfirmDailog
      isShow={confirmImportDailog}
      handleOk={onConfirmImport}
      handleCancel={onCloseConfirmImport}
      title="ยืนยันการนำเข้าสินค้า"
      description={`คุณแน่ใจหรือไม่ว่าต้องการนำเข้าสินค้าใหม่ ${selectProduct.length} รายการ?`}
      confirmBtnTxt="นำเข้าสินค้า"
    />
  )

  return (
    <DetailDrawer
      width={'70%'}
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
    >
      {FilterContent}
      <TableListPage
        columns={columns}
        datas={datas}
        isLoading={detailEvent.IsLoading}
        paginationContent={PaginationContent}
        scrollX={800}
      />
      {/* <LoadingView isShow={detailEvent.IsLoading} /> */}
      <EventModal
        event={[event]}
        enable={visible}
        successCalback={onEventSuccess}
        errorCalback={clearEvent}
      />
      {ConfirmImport}
    </DetailDrawer>
  )
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 90px;
  height: 90px;
  object-fit: cover;
`

const FilterWrapper = styled.div`
  padding: 0 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const WarningText = styled(Label)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.warning};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.caption};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    dataList: selectMasterProductList(state),
    detailEvent: selectDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ImportProduct)
